
/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import { Link } from 'react-router-dom';
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import { Typography } from '@material-ui/core'
import { withStyles } from '@mui/styles'
import { makeStyles } from '@mui/styles';
import { compose } from 'redux';

const styles = makeStyles(theme => ({
  root: {
    position: "relative",
    background: "rgb(44, 45, 46)!important",

    color: "black",
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
    },
  },
  text: {
    color: 'black',
  },
  footer: {
    marginTop: '30px',
    marginBottom: '50px!important',


  },
  list: {
    padding: '0'
  },
  listItem: {
    marginBottom: '5px',
    paddingRight: '5px',
    listStyle: 'none!important'

  },
  listItemLink: {
    lineHeight: '35px!important',
    transition: 'all .25s cubic-bezier(.645,.045,.355,1)!important',
    textDecoration: 'none!important',
    color: 'white!important',
    listStyle: 'none!important'
  },
  footerTitle: {
    marginBottom: '17px!important'
  },

}));

const PageFooter = () => {


  const classes = styles()

  return (
    <div className={classes.root}>
  


      <Container maxWidth="xl" component="footer" className={classes.footer}>
        <Grid container spacing={4} justify="space-evenly">
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h1" className={classes.footerTitle} color="primary" gutterBottom>
              THERAYTEK
            </Typography>

            <Typography variant='h4' className={classes.listItemLink} >
              Email  :  <a href="mailto:info@theraytek.tn" target="_blank" rel="noreferrer" style={{color:'white'}}>info@theraytek.tn</a>
            </Typography>

            <Typography variant='h4' className={classes.listItemLink} >
              Address  : AV. HAJ ALI SOUA KSAR-HELLAL 5070, Monastir, Tunisia.
            </Typography>
            <Typography variant='h4' className={classes.listItemLink} >
              Phone Number  : (216) 24 527 298
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h1" className={classes.footerTitle} color="primary" gutterBottom>
              Company
            </Typography>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                <Link to={"/services"} variant="subtitle1" color="primary" className={classes.listItemLink} >
                <Typography variant='h4' className={classes.listItemLink} >
                    Services
                  </Typography>
                </Link>
              </li>

              <li className={classes.listItem}>
                <Link to={"/contact-us"} variant="subtitle1" color="primary" className={classes.listItemLink} >
                <Typography variant='h4' className={classes.listItemLink} >
                    Contact us
                  </Typography>
                </Link>
              </li>
              <li className={classes.listItem}>
                <Link to={"/about-us"} variant="subtitle1" color="primary" className={classes.listItemLink} >
                <Typography variant='h4' className={classes.listItemLink} >
                    About us
                  </Typography>
                </Link>
              </li>
            </ul>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h1" className={classes.footerTitle} color="primary" gutterBottom>
              Legal
            </Typography>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                <Link to={"/privacypolicy"} variant="subtitle1" className={classes.listItemLink} >
                <Typography variant='h4' className={classes.listItemLink} >
                    Privacy Policy
                  </Typography>
                </Link>
              </li>
              <li className={classes.listItem}>
                <Link to={"/tos"} ariant="subtitle1" className={classes.listItemLink} >
                <Typography variant='h4' className={classes.listItemLink} >
                    TOS
                  </Typography>
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>
        <Grid container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={4}
        className={classes.socialIconsList}
      >
    


        <Grid item xs={12} sm={1} md={1}>
        <a href="https://www.linkedin.com/company/theraytek" target="_blank" rel="noreferrer">
            <img src="/assets/images/icons/linkedin.png" width={30} alt="linkedin" />
          </a>
          <a href="mailto:info@theraytek.tn" target="_blank" rel="noreferrer" style={{marginLeft:'20px'}}>
            <img src="/assets/images/icons/email.png" width={35} alt="email" />
          </a>
        </Grid>
   
   
      </Grid>
      </Container>
   
      <Box mt={3}>
        <Typography variant="h4" align="center" className={classes.listItemLink} >
          {'Copyright © '}
          <Link to={"/"} className={classes.listItemLink}>
            THERAYTEK
          </Link>{' '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
      </Box>
    </div>
  )

}

PageFooter.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default PageFooter;
